"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// standalone pages are used by external parties in order to render these in an iframe
const standAlonePages = ['/searchbox', '/planner', '/embed/search', '/embed/searchbox', '/embed/planner'];
var _default = exports.default = standAlonePages;